import type { ConfiguredFieldOptions } from '@cims-online/shared'

/** Applies each configured field type’s required-value convention. */
export function required(field: ConfiguredFieldOptions): boolean {
  if (field.type === 'comments') return !field.optional
  if (field.type === 'long_text' || field.type === 'selected_by')
    return field.required
  return field.required !== false
}
